import { InputHTMLAttributes } from 'react';

interface SignUpInputProps {
   field: InputHTMLAttributes<HTMLInputElement>;
   label: string;
   helperText?: string;
   id?: string;
   isDisabled?: boolean;
}

export function SignUpInput({
   field,
   label,
   helperText,
   id,
   isDisabled = false,
   ...inputProps
}: SignUpInputProps & InputHTMLAttributes<HTMLInputElement>) {
   return (
      <>
         <label htmlFor={id} className="text-sm font-medium">
            {label}
         </label>
         <input
            id={id}
            disabled={isDisabled}
            className="w-full min-h-10 rounded-lg mt-1"
            {...field}
            {...inputProps}
         />
         {helperText && <p className="text-sm text-muted-foreground">{helperText}</p>}
      </>
   );
}
